<template>
    <section class="child_wrap rqsn_wrapper">
        <div class="carde one flex">
            <div class="right_carde">
                <h2 class="ta_center">3M</h2>
                <div class="btn_color cta">
                    <router-link :to="{ name: 'signup' }">
                        <button>Sign Up</button>
                    </router-link>
                </div>
            </div>
            <div class="left_carde">
                <h3>Free requests every month</h3>
                <p>Signup with email (verified address required for free requests)</p>
                <div class="btn_color cta">
                    <router-link :to="{ name: 'signup' }">
                        <button>Sign Up</button>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="carde flex flex_dir_rr">
            <div class="right_carde">
                <h2 class="ta_center">$0.25<sup>⋆</sup></h2>
                <div class="btn_color cta">
                    <router-link :to="{ name: 'signup' }">
                        <button>Sign Up</button>
                    </router-link>
                </div>
            </div>
            <div class="left_carde">
                <h3>For 100,000 requests</h3>
                <p>
                    <span class="sup">⋆</span>Starting at a base price of $0.50/100k, —a volume discount up to 20% off base rate is automatically
                    applied. Additional discounts will go to Rivet community projects invited to join the “BUITL with Rivet” initiative. (Apply in
                    under 5 minutes on the Rivet Dashboard!)
                </p>
                <div class="btn_color cta">
                    <router-link :to="{ name: 'signup' }">
                        <button>Sign Up</button>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup></script>

<style lang="scss" scoped>
section {
    @include flex(none, none, 2rem 1.5rem);
    @include media("<=tablet") {
        @include flex_col(4rem);
    }
    .sup {
        font-size: 2em;
    }
    .carde {
        background: white;
        padding: 4rem 1.5rem;
        border-radius: 10px;
        justify-content: space-around;
        align-items: center;
        &:nth-child(1) {
            width: 44%;
        }
        &:nth-child(2) {
            width: 59%;
        }
        @include media("<=tablet") {
            width: 100% !important;
        }
        @include media("<=tablet") {
            align-items: center;
            @include flex_col(1rem);
            padding: 2.5rem 0.7rem;
        }
        .right_carde {
            h2 {
                font-weight: bold;
                font-size: 4em;
                color: $blacktext;
                @include media("<=tablet") {
                    font-size: 3.9em;
                }
                @include media("<=phone-tab") {
                    font-size: 3.5em;
                }
            }
            .cta {
                @include media("<=tablet") {
                    display: none;
                }
                button {
                    padding: 1.2rem 0rem;
                    width: 100%;
                    min-width: 11rem;
                }
            }
        }
        .left_carde {
            width: 50%;
            @include flex_col(1.2rem);
            @include media("<=tablet") {
                width: 90%;
                text-align: center;
            }
            .cta {
                display: none;
                @include media("<=tablet") {
                    display: block;
                }
            }
            h3 {
                font-size: 1.4em;
                color: $blacktext;
            }
            p {
                color: $offblack;
            }
        }
    }
}
</style>
